import React , { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Specialoffer from "../includes/Specialoffer";
import Horizontal from "../component/Horizontal";
import ScrollText from "../component/ScrollText";
import Cta from "../component/Cta";
import Blog from "../component/Blog";
import MainTestimonial from "../component/slider/MainTestimonial";
import brand_01 from "../images/brand/brand01.png";
import brand_02 from "../images/brand/brand02.png";
import brand_03 from "../images/brand/brand03.png";
import brand_04 from "../images/brand/brand04.png";
import brand_05 from "../images/brand/brand05.png";
import brand_06 from "../images/brand/brand06.png";
import brand_07 from "../images/brand/brand07.png";
import brand_08 from "../images/brand/brand08.png";
import brand_09 from "../images/brand/brand09.png";
import brand_10 from "../images/brand/brand10.png";
import FeaturesComp from "../component/FeaturesComp";
import { Link } from "react-router-dom";
import home_gif_1 from "../images/gif/home-gif.png";
import home_gif_2 from "../images/Dashboard_V2-2.png";
import home_gif_3 from "../images/r-home.svg";
import Clients from "../component/Clients";
import ivrorder from '../images/ivr-order.png';
import india from '../images/india-map.png';
import gif_01 from '../images/gif/gif-01.png';
import RightToLeft from "../component/slider/RightToLeft";
import courier_01 from "../images/courier/courier-img-01.png"
import courier_02 from "../images/courier/courier-img-02.png"
import courier_03 from "../images/courier/courier-img-03.png"
import courier_04 from "../images/courier/courier-img-04.png"
import courier_05 from "../images/courier/courier-img-05.png"
import courier_06 from "../images/courier/courier-img-06.png"
import courier_07 from "../images/courier/courier-img-07.png"
import courier_08 from "../images/courier/courier-img-08.png"
import courier_09 from "../images/courier/courier-img-09.png"
import courier_10 from "../images/courier/courier-img-10.png"
import PrimaryBtn from "../component/btn/PrimaryBtn";
import px_img_01 from "../images/px-img-01.png";
import px_img_02 from '../images/px-img-02.png'
import map from '../images/map.png';
import HomeSlider from "../component/slider/HomeSlider";
import franchise_01 from "../images/icon/icon-img-01.png";
import franchise_02 from "../images/icon/icon-img-02.png";
import franchise_03 from "../images/icon/icon-img-03.png";
import franchise_04 from "../images/icon/icon-img-04.png";
import vi_img_08 from '../images/vi-img-08.png'
import StickyBoxs from "../component/StickyBoxs";
import VideoPlayer from "../component/VideoPlayer";
import features from '../images/feature-img01.png'
import features01 from '../images/feature-img02.png'
import features02 from '../images/feature-img03.png'
import features03 from '../images/feature-img04.png'
import features04 from '../images/feature-img05.png'
import cricle from '../images/logo/logo-cricle.png'
import cricle01 from '../images/logo/cricle-img01.png'
import cricle02 from '../images/logo/cricle-img02.png'
import cricle03 from '../images/logo/cricle-img03.png'
import cricle04 from '../images/logo/cricle-img04.png'
import cricle05 from '../images/logo/cricle-img05.png'
import cricle06 from '../images/logo/cricle-img06.png'
import cricle07 from '../images/logo/cricle-img07.png'
import EnquiryModal from "../component/forms/EnquiryModal";
import slide01 from '../images/brand/slider-img01.png'
import slide02 from '../images/brand/slider-img02.png'
import slide03 from '../images/brand/slider-img03.png'
import slide04 from '../images/brand/slider-img04.png'
import slide05 from '../images/brand/slider-img05.png'
import slide06 from '../images/brand/slider-img06.png'
import slide07 from '../images/brand/slider-img07.png'
import slide08 from '../images/brand/slider-img08.png'
import slide09 from '../images/brand/slider-img09.png'
export default function Home() {
  const clientsData = [
    { image: brand_01 },
    { image: brand_02 },
    { image: brand_03 },
    { image: brand_04 },
    { image: brand_05 },
    { image: brand_06 },
    { image: brand_07 },
    { image: brand_08 },
    { image: brand_09 },
    { image: brand_10 },
  ];
  const courierData = [
    {image: courier_01},
    {image: courier_02},
    {image: courier_03},
    {image: courier_04},
    {image: courier_05},
    {image: courier_06},
    {image: courier_07},
    {image: courier_08},
    {image: courier_09},
    {image: courier_10},
  ]
  const words = [
    "E-commerce Shipping",
    "Fast Delivery",
    "Smart Logistics",
    "Global Shipping",
  ];

  const [wordIndex, setWordIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  const typingSpeed = 80;
  const deletingSpeed = 40;
  const delayBetweenWords = 1500;

  useEffect(() => {
    const currentWord = words[wordIndex];

    let timeout;

    if (!isDeleting && charIndex < currentWord.length) {
      timeout = setTimeout(() => {
        setCharIndex(charIndex + 1);
      }, typingSpeed);
    } else if (isDeleting && charIndex > 0) {
      timeout = setTimeout(() => {
        setCharIndex(charIndex - 1);
      }, deletingSpeed);
    } else if (!isDeleting && charIndex === currentWord.length) {
      timeout = setTimeout(() => {
        setIsDeleting(true);
      }, delayBetweenWords);
    } else if (isDeleting && charIndex === 0) {
      setIsDeleting(false);
      setWordIndex((prev) => (prev + 1) % words.length);
    }

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, wordIndex]);
  return (
    <div>
      <Helmet>
          <title>ParcelX - Home</title>
      </Helmet>
      <section className="section01">
        <div className="container-fluid">
          <div className="main-section">
            <div className="row">
              <div className="col-md-9 mx-auto text-center mb-5">
                <h2 className="heading d-sm-block d-none ">
                  {" "}
                  The Easiest way of {" "}
                  <span className="typing-text">
                    {words[wordIndex].substring(0, charIndex)}
                  </span>
                  <span className="cursor">|</span>
                </h2>
                <h2 className="heading r-heading d-sm-none d-block ">
                  {" "}
                  The Easiest way of {" "} 
                  <br/>
                  <span className="typing-text">
                    {words[wordIndex].substring(0, charIndex)}
                  </span>
                  <span className="cursor">|</span>
                </h2>
                <p className="subtitle fw-400">
                  ParcelX simplifies shipping with India’s smartest AI-powered
                  platform. Manage end-to-end shipping seamlessly, access
                  multiple carriers in one place, and save time and costs
                  effortlessly.
                </p>
                <div>
                  <Link
                    className="btn btn-secondary"
                    to={"https://seller.parcelx.in/register"}
                  >
                    Get Started for Free <i className="fad fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-top-img">
        <div className="container-fluid">
          <div className="col-md-11 mx-auto d-flex justify-content-center">
            <img src={home_gif_1} className="img-fluid top-img d-sm-block d-none" />
            <img src={home_gif_3} className="img-fluid top-img d-sm-none d-block" />
          </div>
          <div className="orenge-box-section">
            <div className="brand-achieved">
              <p>Brands That Achieved: </p>
              <div className="brand-achieved-items">
                Shipping Starts from Rs. 21/500gm*
              </div>
              <div className="brand-achieved-items">Reduce RTO by 25%</div>
              <div className="brand-achieved-items">
                Improved Communication 
              </div>
              <div className="brand-achieved-items">
                95%+ Successful Deliveries
              </div>
              <div className="brand-achieved-items">
                Analytics that actually solve problems
              </div>
            </div>
            <Clients client={clientsData} />
          </div>
        </div>
      </section>
      <section className="section-02">
        <div className="container-fluid">
          <div className="col-md-11 mx-auto">
            <div className="section-heading">
              <ScrollText text="Why you should trust us: Why Choose Us" />
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 mb-3">
                <div className="trust-card">
                  <img src={ivrorder} className="img-fluid bg-gray" />
                  <div className="trust-content">
                    <h4 className="sub-heading"><span className="text-success fw-600">20%</span> Lower Shipping Rates</h4>
                    <p className="mb-0">Enjoy up to 20% lower shipping rates through ParcelX, designed to help sellers save more while shipping more.</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-3">
                <div className="black-shadow-card">
                  <div className="d-flex align-items-center">
                    <div>
                      <h4 className="sub-heading text-white">29000+ <br/> Pincodes Covered</h4>
                      <p className="text-white mb-0">Ship to even the most remote locations  in the india with our network.</p>
                    </div>
                    <img src={india} className="img-fluid india-map"/>
                  </div>
                </div>
                <div className="primary-box px-0">
                  <div className="primary-box-content">
                    <h4 className="sub-heading text-white">20+ Courier Partners</h4>
                    <p className="text-white">Compare, Book, Track & Analyse in one place</p>
                  </div>
                  <RightToLeft courier={courierData} />
                </div>
              </div>
              <div className="col-lg-4  mb-lg-3">
                <div className="trust-card p-0">
                  <div className="trust-content padding">
                    <h4 className="sub-heading">Multi Channel Integration</h4>
                    <p className="mb-0">Plug & Play- No Need to Code or watch tutorial. Connect your store with ParcelX and let ParcelX handle your shipping.</p>
                  </div>
                  <div className="custom-gif">
                    <div className="scene">
                        <div className="ring r1"></div>
                        <div className="ring r2"></div>
                        <div className="ring r3"></div>
                        <div className="ring r4"></div>

                        <div className="center"><img src={cricle} className="mb-0" /></div>

                        <div className="orbit">
                          <div className="item items-6" style={{ transform: "rotate(0deg) translate(250px) rotate(0deg)" }}>
                            <div className="logo-gif"><img src={cricle01} alt="" /></div>
                          </div>

                          <div className="item items-4" style={{ transform: "rotate(60deg) translate(250px) rotate(-60deg)" }}>
                            <div className="logo-gif"><img src={cricle02} alt="" /></div>
                          </div>

                          <div className="item items-5" style={{ transform: "rotate(120deg) translate(250px) rotate(-120deg)" }}>
                            <div className="logo-gif"><img src={cricle03} alt="" /></div>
                          </div>

                          <div className="item items-3" style={{ transform: "rotate(180deg) translate(250px) rotate(-180deg)" }}>
                            <div className="logo-gif"><img src={cricle04} alt="" /></div>
                          </div>

                          <div className="item items-2" style={{ transform: "rotate(240deg) translate(250px) rotate(-240deg)" }}>
                            <div className="logo-gif"><img src={cricle05} alt="" /></div>
                          </div>

                          <div className="item" style={{ transform: "rotate(300deg) translate(250px) rotate(-300deg)" }}>
                            <div className="logo-gif"><img src={cricle06} alt="" /></div>
                          </div>

                          <div className="item items-1" style={{ transform: "rotate(360deg) translate(250px) rotate(-360deg)" }}>
                            <div className="logo-gif"><img src={cricle07} alt="" /></div>
                          </div>

                        </div>

                    </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section03">
        <div className="cntainer-fluid">
          <div className="col-md-11 mx-auto">
            <div className="section-headeing">
              <ScrollText text="Multiple Integrations: Connect your online store" />
            </div>
            <div className="row align-itms-center">
              <div className="col-md-6 order-md-2">
                <div className="img-marquee">
                  <div className="position-relative h-300">
                      <img src={px_img_01} className="img-fluid right-image" />
                  </div>
                  <div className="marquee-container">
                      <div className="marquee-track new-marquee-img">
                          <div className="marquee-item new-card-img">
                              <img src={slide01} className="img-fluid" alt="" />
                          </div>
                          <div className="marquee-item new-card-img">
                              <img src={slide02} className="img-fluid" alt="" />
                          </div>
                          <div className="marquee-item new-card-img">
                              <img src={slide03} className="img-fluid" alt="" />
                          </div>
                          <div className="marquee-item new-card-img">
                              <img src={slide04} className="img-fluid" alt="" />
                          </div>
                          <div className="marquee-item new-card-map">
                              <img src={slide05} className="img-fluid" alt="" />
                          </div>
                          <div className="marquee-item new-card-img">
                              <img src={slide06} className="img-fluid" alt="" />
                          </div>
                          <div className="marquee-item new-card-map">
                              <img src={slide07} className="img-fluid" alt="" />
                          </div>
                          <div className="marquee-item new-card-img">
                              <img src={slide08} className="img-fluid" alt="" />
                          </div>
                          <div className="marquee-item new-card-img">
                              <img src={slide09} className="img-fluid" alt="" />
                          </div>
                      </div>
                  </div>
              </div>
              </div>
              <div className="col-md-6">
                <p className="heading-des">Seamlessly connect all your sales channels with ParcelX and manage your entire business from one unified platform. From order syncing to real-time tracking and automated shipping, everything works together effortlessly to simplify operations and improve efficiency.</p>
                <ul>
                  <li><b>One Dashboard:</b> Manage Amazon, Shopify, and website orders together.</li>
                  <li><b>Auto Updates:</b> Inventory, tracking, and shipping sync in real time.</li>
                  <li><b>No Manual Work:</b> Fewer errors, faster dispatches, smoother workflow.</li>
                  <li><b>Better Experience:</b> Smooth operations = happier customers.</li>
                </ul>
                <p className="heading-des">Work smarter with seamlessly connected channels</p>
                <PrimaryBtn text="Explore Integration" href={'channel-integration'} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section03">
        <div className="cntainer-fluid">
          <div className="col-md-11 mx-auto">
            <div className="section-headeing">
              <ScrollText text="20+ Courier Partners: Choose what’s best for you" />
            </div>
            <div className="row align-itms-center">
              <div className="col-md-6">
                <div className="position-relative">
                  <img src={px_img_02} className="img-fluid left-image" />
                </div>
              </div>
              <div className="col-md-6">
                <p className="heading-des">Ship smarter with ParcelX by accessing 20+ trusted courier partners from a single dashboard. Select the best option for every order based on speed, cost, and service availability—giving your business complete shipping flexibility.</p>
                <ul>
                  <li><b>Smart Choice:</b> Compare multiple courier options in one place.</li>
                  <li><b>Better Rates:</b> Pick the most cost-effective shipping partner.</li>
                  <li><b>Wider Reach:</b> Deliver across India with reliable networks.</li>
                  <li><b>Flexible Shipping: </b> Choose the right courier for every order.</li>
                </ul>
                <p className="heading-des">Work smarter with AI courier allocation engine.</p>
                <PrimaryBtn text="Explore Courier Partners" href={'courier-partners'} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section03">
        <div className="container-fluid">
          <div className="col-md-11 mx-auto">
            <div className="row">
              <div className="col-md-11 mx-auto">
                <div className="section-heading text-center">
                  <h2 className="sub-heading-2">Experience the all new <b>ParcelX Dashboard</b></h2>
                  <p>ParcelX simplifies shipping with India’s smartest AI-powered platform.  Manage end-to-end shipping seamlessly, access multiple carriers in one place, and save time and costs effortlessly.</p>
                </div>
              </div>
            </div>
            <VideoPlayer />
          </div>
        </div>
      </section>
      <section className="section03 big-marquee">
        <RightToLeft courier={courierData} />
        <div className="container-fluid pe-0 mt-5">
          <img src={map} className="img-fluid left-map" />
          <div className="img-content-text">
            <div className="col-md-11 mx-auto">
              <div className="section-heading">
                <h2 className="sub-heading"><span>Services we offer</span> to make your logistics efficient</h2>
              </div>
            </div>
            <Horizontal />
          </div>
        </div>
      </section>
      <section className="section04">
        <div className="container-fluid">
            <div className="col-11 mx-auto">
                <div className="section-heading">
                    <h2 className="heading"><span>Our Features:</span> Passion for Logistics & Ecom Shipping</h2>
                    <p>ParcelX combines powerful technology with deep logistics expertise to simplify shipping for businesses of all sizes. From automation to real-time insights, every feature is designed to help you ship smarter, faster, and more efficiently.</p>
                </div>
            </div>
            <div className="features-main-box">
                <div className="features-boxs">
                    <div className="features-main-card">
                        <div className="">
                            <h2 className="sub-heading">No Monthly Charges</h2>
                            <p>Tired of subscriptions? We hear you. ParcelX only charges you for your shipping. No extra charges or subscription required.</p>
                        </div>
                        <img src={features} alt className="img-fluid" />
                    </div>
                    <div className="features-main-card second-card flex-card">
                        <div className="">
                            <h2 className="sub-heading">Multi Channel Integration</h2>
                            <p>Sync all your channels & marketplaces and put them on a single dashboard to have all the data at a single spot.</p>
                        </div>
                        <img src={features01} height="212" alt="" />
                    </div>
                    <div className="features-main-card second-card flex-card">
                        <div className="">
                            <h2 className="sub-heading">Early COD Remittance</h2>
                            <p>We know how important money is. With timely COD remittance, you don’t have to wait for your money </p>
                        </div>
                        <img src={features02} height="212" className="mt-4" alt="" />
                    </div>
                </div>
                <div className="features-boxs">
                    <div className="features-main-card second-card featurs-four mb-0">
                        <div className="img-features">
                            <h2 className="sub-heading">Dedicated Manager</h2>
                            <p>We care about you. We give you your personal account manager to solve all your problems or queries, anytime.</p>
                        </div>
                        <img src={features03} className="img-fluid mb--50" alt="" />
                    </div>
                    <div className="features-main-card mb-0">
                        <h2 className="sub-heading">Actionable Insights & Your Own Tracking Page</h2>
                        <p>AI analyzes user behavior, traffic, and conversions to personalize marketing and optimize your website.</p>
                        <img src={features04} className="img-fluid mb--32" alt="" />
                    </div>
                </div>
            </div>
        </div>
      </section>
      {/* <section className="section04">
          <div className="container-fluid">
            <div className="col-md-11 mx-auto">
              <h2 className="heading"><span>Our Features:</span> Passion for Logistics & Ecom Shipping</h2>
              <p>ParcelX combines powerful technology with deep logistics expertise to simplify shipping for businesses of all sizes. From automation to real-time insights, every feature is designed to help you ship smarter, faster, and more efficiently.</p>
            </div>
            <FeaturesComp />
          </div>
      </section> */}
      <section className="section03">
        <div className="container-fluid">
          <HomeSlider />
        </div>
      </section>
      <section className="section03 bg-gradient">
        <div className="cntainer-fluid">
          <div className="col-md-11 mx-auto">
            <div className="section-headeing">
              <ScrollText text="Become a ParcelX Franchise Partner" />
            </div>
            <div className="row align-itms-center">
              <div className="col-md-5 order-md-2 mb-3">
                <div className="position-relative">
                  <img src={vi_img_08} className="img-fluid right-image mt--50" />
                </div>
              </div>
              <div className="col-md-7">
                <p className="heading-des">Join India's fastest-growing logistics network. Get access to cutting-edge technology, comprehensive training, and ongoing support to build a profitable logistics business.</p>
                <div className="row">
                  <div className="col-sm-6 mb-3">
                    <div className="franchise-box">
                      <div className="franchise-image">
                        <img src={franchise_03} />
                      </div>
                      <div className="franchise-content">
                        <h2 className="f-18 fw-500">Dedicated Panel</h2>
                        <p className="f-14 fw-400 mb-0">Complete control panel with real-time analytics and reporting.</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 mb-3">
                    <div className="franchise-box">
                      <div className="franchise-image">
                        <img src={franchise_04} />
                      </div>
                      <div className="franchise-content">
                        <h2 className="f-18 fw-500">Easy Onboarding & Training</h2>
                        <p className="f-14 fw-400 mb-0">Get step-by-step guidance and training to launch and grow your franchise with confidence.</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 mb-3">
                    <div className="franchise-box">
                      <div className="franchise-image">
                        <img src={franchise_01} />
                      </div>
                      <div className="franchise-content">
                        <h2 className="f-18 fw-500">24/7 Support</h2>
                        <p className="f-14 fw-400 mb-0">Dedicated support team always ready to help you succeed.</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 mb-3">
                    <div className="franchise-box">
                      <div className="franchise-image">
                        <img src={franchise_02} />
                      </div>
                      <div className="franchise-content">
                        <h2 className="f-18 fw-500">Growth Analytics</h2>
                        <p className="f-14 fw-400 mb-0">Track your performance with advanced business insights.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <EnquiryModal />
              </div>
            </div>
          </div>
        </div>
      </section>
      <StickyBoxs />      
      <MainTestimonial />
      {/* <Blog /> */}
      <Cta />
    </div>
  );
}
